import _Promise from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/core-js/promise';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

var _17aa4d8c = function _17aa4d8c() {
	return import('../pages/culture/index.vue' /* webpackChunkName: "pages/culture/index" */).then(function (m) {
		return m.default || m;
	});
};
var _887de8cc = function _887de8cc() {
	return import('../pages/curing/index.vue' /* webpackChunkName: "pages/curing/index" */).then(function (m) {
		return m.default || m;
	});
};
var _4c833ce1 = function _4c833ce1() {
	return import('../pages/engin/index.vue' /* webpackChunkName: "pages/engin/index" */).then(function (m) {
		return m.default || m;
	});
};
var _6157286d = function _6157286d() {
	return import('../pages/garden/index.vue' /* webpackChunkName: "pages/garden/index" */).then(function (m) {
		return m.default || m;
	});
};
var _fb5ca1d4 = function _fb5ca1d4() {
	return import('../pages/indexs.vue' /* webpackChunkName: "pages/indexs" */).then(function (m) {
		return m.default || m;
	});
};
var _04d552cb = function _04d552cb() {
	return import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */).then(function (m) {
		return m.default || m;
	});
};
var _244ab937 = function _244ab937() {
	return import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */).then(function (m) {
		return m.default || m;
	});
};
var _6cd85816 = function _6cd85816() {
	return import('../pages/us/index.vue' /* webpackChunkName: "pages/us/index" */).then(function (m) {
		return m.default || m;
	});
};
var _f555364e = function _f555364e() {
	return import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */).then(function (m) {
		return m.default || m;
	});
};
var _ed197d38 = function _ed197d38() {
	return import('../pages/us/contact.vue' /* webpackChunkName: "pages/us/contact" */).then(function (m) {
		return m.default || m;
	});
};
var _18f960d4 = function _18f960d4() {
	return import('../pages/us/join.vue' /* webpackChunkName: "pages/us/join" */).then(function (m) {
		return m.default || m;
	});
};
var _38c8396e = function _38c8396e() {
	return import('../pages/us/team.vue' /* webpackChunkName: "pages/us/team" */).then(function (m) {
		return m.default || m;
	});
};
var _b4e730b6 = function _b4e730b6() {
	return import('../pages/us/teams/_id.vue' /* webpackChunkName: "pages/us/teams/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _02c0e81a = function _02c0e81a() {
	return import('../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _5ad39d5f = function _5ad39d5f() {
	return import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _ef9230a6 = function _ef9230a6() {
	return import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(function (m) {
		return m.default || m;
	});
};

if (process.client) {
	window.history.scrollRestoration = 'manual';
}
var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
	// if the returned position is falsy or an empty object,
	// will retain current scroll position.
	var position = false;

	// if no children detected
	if (to.matched.length < 2) {
		// scroll to the top of the page
		position = { x: 0, y: 0 };
	} else if (to.matched.some(function (r) {
		return r.components.default.options.scrollToTop;
	})) {
		// if one of the children has scrollToTop option set to true
		position = { x: 0, y: 0 };
	}

	// savedPosition is only available for popstate navigations (back button)
	if (savedPosition) {
		position = savedPosition;
	}

	return new _Promise(function (resolve) {
		// wait for the out transition to complete (if necessary)
		window.$nuxt.$once('triggerScroll', function () {
			// coords will be used if no selector is provided,
			// or if the selector didn't match any element.
			if (to.hash) {
				var hash = to.hash;
				// CSS.escape() is not supported with IE and Edge.
				if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
					hash = '#' + window.CSS.escape(hash.substr(1));
				}
				try {
					if (document.querySelector(hash)) {
						// scroll to anchor by returning the selector
						position = { selector: hash };
					}
				} catch (e) {
					console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
				}
			}
			resolve(position);
		});
	});
};

export function createRouter() {
	return new Router({
		mode: 'history',
		base: '/',
		linkActiveClass: 'nuxt-link-active',
		linkExactActiveClass: 'nuxt-link-exact-active',
		scrollBehavior: scrollBehavior,
		routes: [{
			path: "/culture",
			component: _17aa4d8c,
			name: "culture"
		}, {
			path: "/curing",
			component: _887de8cc,
			name: "curing"
		}, {
			path: "/engin",
			component: _4c833ce1,
			name: "engin"
		}, {
			path: "/garden",
			component: _6157286d,
			name: "garden"
		}, {
			path: "/indexs",
			component: _fb5ca1d4,
			name: "indexs"
		}, {
			path: "/news",
			component: _04d552cb,
			name: "news"
		}, {
			path: "/project",
			component: _244ab937,
			name: "project"
		}, {
			path: "/us",
			component: _6cd85816,
			name: "us"
		}, {
			path: "/video",
			component: _f555364e,
			name: "video"
		}, {
			path: "/us/contact",
			component: _ed197d38,
			name: "us-contact"
		}, {
			path: "/us/join",
			component: _18f960d4,
			name: "us-join"
		}, {
			path: "/us/team",
			component: _38c8396e,
			name: "us-team"
		}, {
			path: "/us/teams/:id?",
			component: _b4e730b6,
			name: "us-teams-id"
		}, {
			path: "/news/:id",
			component: _02c0e81a,
			name: "news-id"
		}, {
			path: "/project/:id",
			component: _5ad39d5f,
			name: "project-id"
		}, {
			path: "/",
			component: _ef9230a6,
			name: "index"
		}],

		fallback: false
	});
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/router.js
// module id = ./.nuxt/router.js
// module chunks = 18